<template>
	<div class="menu-item-picker" :class="{ 'is-active': isActive }" @click="onClick">
		<TextAlignLeftSvg />
	</div>
</template>

<script>
import TextAlignLeftSvg from './assets/TextAlignLeftSvg.vue';

const DIRECTION = 'left';

// export default defineComponent({
export default {
	name: 'TextAlignCenterFormatting',
	components: {
		TextAlignLeftSvg,
	},
	props: {
		editor: { type: Object },
	},
	computed: {
		isActive() {
			return this.editor.isActive({ textAlign: DIRECTION });
		},
	},
	methods: {
		onClick() {
			if (this.isActive) {
				this.editor.chain().focus().unsetTextAlign().run();
			} else {
				this.editor.chain().focus().setTextAlign(DIRECTION).run();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.menu-item-picker {
	margin-top: 2px;
}
</style>
